import { Waves, Bike, Check, ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const ServicesPage = () => {
  const { t, lang } = useLang();
  const blocks = [
    {
      icon: Waves,
      title: t("services.swim_title"),
      body: t("services.swim_body"),
      bullets: [
        t("services.swim_bullet1"),
        t("services.swim_bullet2"),
        t("services.swim_bullet3"),
        t("services.swim_bullet4"),
        t("services.swim_bullet5"),
      ],
      img: "https://images.pexels.com/photos/29280139/pexels-photo-29280139.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      accent: "bg-forest",
      reverse: false,
      testId: "service-block-swim",
    },
    {
      icon: Bike,
      title: t("services.cycle_title"),
      body: t("services.cycle_body"),
      bullets: [
        t("services.cycle_bullet1"),
        t("services.cycle_bullet2"),
        t("services.cycle_bullet3"),
        t("services.cycle_bullet4"),
        t("services.cycle_bullet5"),
        t("services.cycle_bullet6"),
      ],
      img: "https://images.pexels.com/photos/18823753/pexels-photo-18823753.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      accent: "bg-burnt",
      reverse: true,
      testId: "service-block-cycle",
    },
  ];

  return (
    <div data-testid="page-services" className="bg-white">
      <section className="container-flow section-pad">
        <p className="text-overline">{t("services.overline")}</p>
        <h1 className="mt-4 hd-italic text-5xl md:text-7xl text-forest leading-[0.95] max-w-4xl">{t("services.title")}</h1>
        <p className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">{t("services.subtitle")}</p>

        <div className="mt-10 inline-flex items-center gap-3 border border-burnt bg-bone px-5 py-3" data-testid="certification-badge">
          <ShieldCheck size={20} className="text-burnt" />
          <p className="font-heading uppercase tracking-widest text-xs font-bold text-forest">
            {lang === "fr"
              ? "Certifiés Cyclisme Canada · Société de sauvetage"
              : "Certified by Cyclisme Canada · Société de sauvetage"}
          </p>
        </div>
      </section>

      {blocks.map((b, i) => {
        const Icon = b.icon;
        return (
          <section key={i} data-testid={b.testId} className="border-t border-border">
            <div className="container-flow section-pad grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
              <div className={`lg:col-span-6 ${b.reverse ? "lg:order-2" : ""}`}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={b.img} alt={b.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
              </div>
              <div className={`lg:col-span-6 ${b.reverse ? "lg:order-1" : ""}`}>
                <div className={`inline-flex items-center justify-center w-14 h-14 ${b.accent} text-white`}>
                  <Icon size={26} />
                </div>
                <h2 className="mt-6 hd-italic text-5xl md:text-6xl text-forest leading-tight">{b.title}</h2>
                <p className="mt-6 text-lg text-muted-foreground leading-relaxed">{b.body}</p>
                <ul className="mt-8 space-y-3">
                  {b.bullets.map((bl, j) => (
                    <li key={j} className="flex items-start gap-3 text-base">
                      <Check size={18} className="text-burnt mt-1 shrink-0" /> <span>{bl}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/reservation" className="btn-primary mt-10">
                  {t("nav.book_cta")} <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default ServicesPage;
